import { render, staticRenderFns } from "./distributorrecord.vue?vue&type=template&id=305cbb8e&scoped=true"
import script from "./distributorrecord.vue?vue&type=script&lang=js"
export * from "./distributorrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305cbb8e",
  null
  
)

export default component.exports